import { attr, belongsTo, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const Student = ApplicationRecord.extend({
  static: {
    jsonapiType: 'students',
  },
  attrs: {
    availableSeasonsToPurchase: attr({ persist: false }),
    firstName: attr(),
    lastName: attr(),
    email: attr(),
    dob: attr(),
    grade: attr(),
    // Server-derived (Student#grad_year); never sent back.
    gradYear: attr({ persist: false }),
    teacher: attr(),
    idOnly: attr(),
    enrolled: attr(),
    studentId: attr(),
    schoolId: attr(),
    educatorId: attr(),
    school: belongsTo(),
    orderPackage: hasMany(),
    validateStudentId: attr(),
    place: attr(),
    userType: attr(),
  },
  methods: {
    fullName(surnameFirst = false) {
      if (surnameFirst) return `${this.lastName}, ${this.firstName}`

      return `${this.firstName} ${this.lastName}`
    },
  },
})

export default Student
